import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { getInitials } from '@/lib/format'

interface EntityAvatarProps {
    name: string
    size?: 'sm' | 'default' | 'lg'
    className?: string
}

const SIZES = {
    sm: 'size-7 text-[10px] rounded-md',
    default: 'size-9 text-xs rounded-lg',
    lg: 'size-12 text-sm rounded-xl'
}

// Initials tile for companies and people
export const EntityAvatar: FC<EntityAvatarProps> = ({ name, size = 'default', className }): ReactNode => {
    return (
        <span
            className={cn(
                'flex shrink-0 items-center justify-center border bg-secondary font-semibold text-secondary-foreground',
                SIZES[size],
                className
            )}
            aria-hidden='true'
        >
            {getInitials(name)}
        </span>
    )
}
